import { render, staticRenderFns } from "./DownloadFinalOrder.vue?vue&type=template&id=bf129d80"
import script from "./DownloadFinalOrder.vue?vue&type=script&lang=js"
export * from "./DownloadFinalOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports